import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb/irb-common/interfaces/grid-layout.service';
import { MmcPaidModelAgreementDialogComponent } from './mmc-paid-model-agreement-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class PaidModelAgreementGridLayoutService implements GridLayoutService<MmcPaidModelAgreementDialogComponent> {

  constructor() { }

  getFrameworkComponents() {
    return {};
  }

  getColumnDefs() {
    return [
      {
        headerName: "Manager Model Name",
        field: "mmcModelName",
        cellRenderer: "cellRendererFormatter",
      },
      {
        headerName: "Manager",
        field: "managerName",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        },
        maxWidth: 125
      },
      {
        headerName: "Signor ID",
        field: "signedBy",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        },
        maxWidth: 125
      },
      {
        headerName: "Date",
        field: "signedOn",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: { type: "date", format: "MM/dd/yyyy" },
        maxWidth: 125,
        sort: 'desc',
        comparator: this.sortSigned.bind(this)
      }
    ];
  }

  private sortSigned(a: any, b: any) {
    if (a === null || typeof a === "undefined") {
      return -1;
    } else if (b === null || typeof b === "undefined") {
      return 1;
    } else {
      return a < b ? -1 : a > b ? 1 : 0;
    }
  }
}
